module.exports = __webpack_public_path__ + "static/img/new_dlt.29f5530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_dlt.png
// module id = 9FZW
// module chunks = 101